module.exports = __webpack_public_path__ + "static/media/robot-orange-happy-head.0feed084.svg";